import { getAdmins } from "../../../api/admins";

export const FIELDS = [
  { key: "date", label: "Date", type: "date" },
  {
    key: "admins",
    label: "Admin",
    type: "select",
    apiResKey: "admins",
    api: getAdmins,
    isMulti: true,
  },
];
